"use strict";

function NetworkErrorMessage() {
  // contextHtml is prepended to whatever message the error resolves to, rather than
  // replacing it the way htmlErrorMessage does, so a caller can explain what the failure
  // means for the user without discarding the API's own reason - a 422's field messages
  // in particular.
  function get(error, action, htmlErrorMessage = null, contextHtml = null, endHtml = null) {
    const message = htmlErrorMessage
      ? addErrorMessageEnd(htmlErrorMessage, endHtml)
      : getErrorMessage(error, action, endHtml);

    return contextHtml ? `${contextHtml} ${message}` : message;
  }

  function getErrorMessage(error, action, endHtml) {
    let message = `The ${action} has failed`;

    if (error instanceof UploadLimitError) {
      return error.message;
    }

    // A 422 means the user's own input was rejected, so the API's field messages are shown on
    // their own - the generic prefix and the contact-support tail would both misdirect someone
    // who just needs to correct a field.
    const validationMessage = getValidationMessage(error);
    if (validationMessage) {
      return validationMessage;
    }

    if (error instanceof ApiError) {
      const response = error.xhrResponse;
      const errorReason = getApiErrorReason(response);
      message += ` with error code ${response.status}${errorReason ? ` (${errorReason})` : ""}`;
    }

    message += ".";
    return addErrorMessageEnd(message, endHtml);
  }

  function getValidationMessage(error) {
    if (!(error instanceof ApiError) || error.xhrResponse.status !== 422) {
      return null;
    }

    const response = error.xhrResponse.responseJSON;
    const fieldErrors = response?.errors;

    return fieldErrors ? Object.values(fieldErrors).flat().join("\n") : (response?.message ?? null);
  }

  function getApiErrorReason(response) {
    const reasonsByCode = {
      0: "network error",
      410: "file is missing",
      500: "server error",
    };
    let errorReason = response.statusText.toLowerCase();

    if (["", "error"].includes(errorReason)) {
      errorReason = null;
    }

    if (response.status === 400 && response.responseJSON?.error) {
      return response.responseJSON.error;
    }

    if (reasonsByCode[response.status]) {
      errorReason = reasonsByCode[response.status];
    }

    return errorReason;
  }

  function addErrorMessageEnd(message, endHtml) {
    return `${message} ${endHtml ?? `Please try again later or ${supportLinkHtml} for assistance.`}`;
  }

  const supportLinkHtml =
    "<a href='https://kb.2ndnaturewater.com/knowledge/kb-tickets/new' target='_blank'>contact support</a>";

  return {
    get,
    supportLinkHtml,
  };
}

module.exports = NetworkErrorMessage();

const ApiError = require("../errors/apiError");
const UploadLimitError = require("../errors/uploadLimitError");
